import { Preview } from "../../../../../types/IAction";
import * as actions from "../../../../actions/totalPass";
import { GetClubesAccesoTotalPass } from "../../../../reducers/totalPass";

export interface TabAccesosDispatcher {
  getClubesAccesoTotalPass: (
    idPersona: any
  ) => Promise<Preview<GetClubesAccesoTotalPass>>;
}

export const tabBitacoraDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => TabAccesosDispatcher = dispatch => ({
  getClubesAccesoTotalPass: (idPersona: any) => {
    return dispatch(actions.getClubesAccesoTotalPass(idPersona));
  }
});
